import { useCallback } from 'react'
import { useSpritzPaySDK } from '../../../../../contracts/useSpritzPaySDK'
import { useContractFunction } from '../../../../../web3/hooks/useContractFunction'

export const useSpritzPayArgs = (sourceTokenAddress: string) => {
    const spritzSdk = useSpritzPaySDK()
    const contract = spritzSdk.getContract()
    const paymentFunction = spritzSdk.getContractMethodForPayment(sourceTokenAddress)

    const contractPayFunction = useContractFunction(
        contract,
        // @ts-ignore
        paymentFunction
    )

    const getPaymentArgs = useCallback(
        async (amount: number, paymentReference: string, currentTime: Date = new Date()) => {
            console.log('Starting call to SDK', {
                sourceTokenAddress,
                amount,
                paymentReference,
                currentTime,
            })

            const { args, data, additionalHops, requiredTokenInput } =
                //@ts-ignore
                await spritzSdk.getPaymentArgs(
                    //@ts-ignore
                    paymentFunction,
                    sourceTokenAddress,
                    amount,
                    paymentReference,
                    currentTime.getTime()
                )

            console.log('SDK result', {
                paymentFunction,
                args,
                data,
                additionalHops,
                requiredTokenInput,
            })

            return { args, additionalHops, requiredTokenInput }
        },
        [paymentFunction, sourceTokenAddress, spritzSdk]
    )

    return { paymentFunction, contractPayFunction, getPaymentArgs }
}
